/// <reference path="../modules/blocks.storage.module.ts" />
/// <reference path="../objects/classes/storagebase.ts" />

module Blocks {
    export class SessionStorage extends App.Classes.StorageBase implements App.Interfaces.IStorageBase {
        static factoryId: string = "sessionStorageFactory";

        constructor($window: ng.IWindowService) {
            super(sessionStorage);

        }

    }
    
    Blocks.storage.factory(SessionStorage.factoryId, ['$window', ($window) => new SessionStorage($window)]);
}